<ion-card-header>
  <ion-card-title color="primary">{{title}}</ion-card-title>
</ion-card-header>
<ion-card-content>
  <ion-list *ngIf="objectsWithStock">
    <ion-item [detail]="true" [button]="true" *ngFor="let obj of objectsWithStock | hasStockObject"
      (click)="openBufferstock(obj.stock_object.id, obj.id)">
      <ion-icon slot="start" name="layers-outline"></ion-icon>
      <ion-label>
        {{obj.stock_object.name}}
      </ion-label>
    </ion-item>
  </ion-list>
</ion-card-content>